

export const KEYS_LICENCIAS = {
    IdCondicion: "IdCondicion",
    IdTipoDeCondicion: "IdTipoDeCondicion",
    IdTipoLicenciaCondicion: "IdTipoLicenciaCondicion",
    Empleado: "Empleado",
    Aprobador: "Aprobador",
    Area:"Area",
    FechaInicioCondicion: "FechaInicioCondicion",
    FechaFinCondicion: "FechaFinCondicion",
    FirmaLicenciaCondicion: "FirmaLicenciaCondicion",
    PapeletaLicenciaCondicion: "PapeletaLicenciaCondicion",
    SustentoLicenciaCondicion: "SustentoLicenciaCondicion",
    MotivoSolicitud:"MotivoSolicitud",
    HoraInicio: "HoraInicio",
    HoraFin:"HoraFin",
    RegistradoEnOfisis: "RegistradoEnOfisis",
    PuedeToggleRegistradoEnOfisis: "PuedeToggleRegistradoEnOfisis",
    ComentarioRechazoOrObservacion: "ComentarioRechazoOrObservacion",
    IdEstadoAprobacion: "IdEstadoAprobacion",

    ComentarioTermino: "ComentarioTermino",
    SustentoFileTermino: "SustentoFileTermino",

    PuedeToggleTieneBonoCapilla: "PuedeToggleTieneBonoCapilla",
    TieneBonoCapilla: "TieneBonoCapilla",
    MostrarCampoBonoCapilla: "MostrarCampoBonoCapilla",
    LinkPolitica:"LinkPolitica"
};